import React from "react";
import Navbar2 from "../../Components/Navbar2/Navbar2";
import { Footer } from '../../Components/Footer/Footer';
import UniMarketHome from "../../Components/UniMarketHome/UniMarketHome";

const UniMarketHomePg = () => {
  return (
    <>
    <Navbar2 />
    <UniMarketHome />
    <Footer />
    </>
  );
};

export default UniMarketHomePg;
